import { gql } from "@apollo/client";

const CREATE_COURSE_PREFILLED = gql`
  mutation createCoursePrefilled($courseFile: String, $baseUrl: String, $apiKey: String, $schacCode: String)
    {createCoursePrefilled(courseFile: $courseFile, baseUrl: $baseUrl, apiKey: $apiKey, schacCode: $schacCode) {
      success
      errors {
        row
        path
        message
      }
      data
    }  
  }`
;

export default CREATE_COURSE_PREFILLED;
